import { CnInputTextArea as CnInputTextAreaView } from './cn-input-textarea';
import { withI18n } from 'panda-i18n';
import locale from "../../locales";
export var CnInputTextArea = withI18n(CnInputTextAreaView, { locale: locale });
